import { render, staticRenderFns } from "./SchedulePriceEdit.vue?vue&type=template&id=a9c806ba"
import script from "./SchedulePriceEdit.vue?vue&type=script&lang=js"
export * from "./SchedulePriceEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports